import { imageModel } from "./defaults";

export const qwenImage3 = imageModel("qwen-image-3", "Qwen Image 3", {
  text: "alibaba/qwen-image-3/text-to-image",
});
